export default [
  // {
  //     title: 'Discover',
  //     route: 'discover',
  //     icon: 'GlobeIcon',
  // },
  // {
  //  title: 'Popular Users',
  //  route: 'popular-users',
  //  icon: 'StarIcon',
  // },
  //{
  //  title: 'New Users',
  //  route: 'new-users',
  //  icon: 'ZapIcon',
  //},
  //{
  //  title: 'Nearby',
  //  route: 'near-by',
  //  icon: 'GitMergeIcon',
  //},
  //{
  //  title: 'For You',
  //  route: 'for-you',
  //  icon: 'HeartIcon',
  //},
  //{
  //  title: 'Online Users',
  //  route: 'online-users',
  //  icon: 'WifiIcon',
  //},
  //{
  //  title: 'Video Call Users',
  //  route: 'video-call-users',
  //  icon: 'VideoIcon',
  //},
  {
    title: 'Chat Menu Title',
    route: 'chat',
    icon: 'MessageSquareIcon',
  },
  // {
  //     title: 'Market',
  //     route: 'market',
  //     icon: 'ShoppingCartIcon',
  // },
  //{
  //  title: 'Interaction',
  //  icon: 'CopyIcon',
  //  children: [
  //    { title: 'Users I like', route: 'interaction.likes' },
  //    { title: 'People who like me', route: 'interaction.liked' },
  //    { title: 'Blocked', route: 'interaction.blocked' },
  //  ],
  //},
  //{
    //title: 'Calls',
    //icon: 'PhoneCallIcon',
    //route: 'calls',
    // children: [
    //   { title: 'With Voice', route: 'calls.voice' },
    //   { title: 'With Video', route: 'calls.video' },
    // ],
  //},
  {
    title: 'Account Status',
    route: 'account-status',
    icon: 'AirplayIcon',
  },
  // {
  //   title: 'My Gains',
  //   route: 'gains',
  //   icon: 'AwardIcon',
  // },
  // {
  //   title: 'Cashouts Page Title',
  //   route: 'cashouts',
  //   icon: 'DownloadCloudIcon',
  // },
  {
    title: 'Tasks & Rewards',
    route: 'rewards',
    icon: 'GiftIcon',
  },
  {
    title: 'Moments',
    route: { name: 'moments', query: { tab: 'discover' } },
    icon: 'ActivityIcon',
  },
  {
    title: 'Settings',
    route: 'settings',
    icon: 'SettingsIcon',
  },
]
